import { toTitleCase } from "../../../../Utils/stringUtls";
import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";

const ValueAddedServicesOverview = ({ data }) => {
  const {
    value_added_service_other_service_additional_setup_monthly_minimum,
    value_added_service_other_service_additional_setup_monthly_minimum_other,
  } = data["4_5"];

  const servicesValue = [
    ...(value_added_service_other_service_additional_setup_monthly_minimum ?? [])
      .filter((s) => s?.length && s !== "other")
      .map((s) => s.split("-").map(toTitleCase).join(" ")),
    ...(value_added_service_other_service_additional_setup_monthly_minimum?.includes("other") &&
    value_added_service_other_service_additional_setup_monthly_minimum_other?.length
      ? [`Other (${toTitleCase(value_added_service_other_service_additional_setup_monthly_minimum_other)})`]
      : []),
  ].join(", ");

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid grid" className="review-summary-gap">
        <div i2c-grid="12@md" className="review-summary-sub-heading">
          <div className="fw-700 font-bold">Value Added Services</div>
        </div>
        <ReviewAttribute
          label="Additional setup and monthly minimum may apply."
          value={servicesValue || "-"}
        />
      </div>
    </div>
  );
};
export default ValueAddedServicesOverview;
